import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Typography, Grid, Button } from '@material-ui/core';

// CONSTANTS
import {
  ROUTE_START,
  ROUTE_DISCOVER,
  ROUTE_RESULTS,
  ROUTE_PARTNER_DISCOVER,
} from '@/constants/routes';
import { LOCATIONS_APP_PAGE } from '@/constants/locations';

// UTILITY
import { updateUrl, sendParentMessage } from '@/utility/common';
import { externalLink, getExternalUrlParams, analyticsStartFormLink } from '@/utility/analytics';
import { getLink } from '@/utility/routes';

// HOC
import withRouter from '@/hoc/withRouter';

// COMPONENTS
import Link from '@/components/Link';

// STYLES
import { FilterWrapper } from './styles';

class BackToResults extends PureComponent {
  handleSendParentMessage = () => {
    sendParentMessage({ goToTop: true });
  };

  handleStartClick = () => {
    analyticsStartFormLink({
      location: LOCATIONS_APP_PAGE,
      type: 'Link',
    });

    this.handleSendParentMessage();
  };

  handleVisitSite = () => {
    const {
      data: { app },
      partner,
      analyticsUserId,
    } = this.props;
    const externalUrlParams = getExternalUrlParams({ unique_id: analyticsUserId });
    const href = updateUrl(app.url, externalUrlParams);

    const properties = {
      location: 'app page',
      href,
      app_id: app.id,
      type: 'app',
      service_name: app.name,
      is_affiliate: !!app.is_affiliate,
      partner: partner?.slug,
      partner_id: partner?.id,
    };

    externalLink(properties);
  };

  render() {
    const {
      t,
      data,
      partner,
      analyticsUserId,
      router: {
        location: { state },
      },
      unique_id,
    } = this.props;

    const externalUrlParams = getExternalUrlParams({ unique_id: analyticsUserId });
    const isFromDiscover =
      state &&
      (state.from === ROUTE_DISCOVER ||
        state.from === getLink(ROUTE_PARTNER_DISCOVER, { partner: partner?.slug }));
    const hasPartner = !!Object.keys(partner).length;
    const partnerSettings = partner?.settings || {};

    let use_marketplace = true;
    let use_fmb = true;

    if (hasPartner) {
      use_marketplace = !!partnerSettings.use_marketplace;
      use_fmb = !!partnerSettings.use_fmb;
    }

    return (
      <FilterWrapper className="back-to-results-wrapper">
        <Grid container spacing={4} justifyContent="space-between">
          <Grid item xs={12} sm={4}>
            <Typography className="subtitle m-b-20" variant="h6" align="center">
              {t('appDetails.backToResults.visitSiteTitle.title', { appName: data.app.name })}
            </Typography>
            <div className="text-center">
              <Button
                component="a"
                className="m-b-20"
                href={updateUrl(data.app.url, externalUrlParams)}
                target="_blank"
                color="primary"
                onClick={this.handleVisitSite}
              >
                {data.app.external_button_text ?? t('buttons.visitSite')}
              </Button>
            </div>
          </Grid>
          {isFromDiscover && use_marketplace && (
            <Grid item xs={12} sm={4}>
              <Typography className="subtitle m-b-20" variant="h6" align="center">
                {t('appDetails.backToResults.marketplace.title')}
              </Typography>
              <div className="text-center">
                <Button
                  className="m-b-20"
                  component={Link}
                  to={ROUTE_DISCOVER}
                  variant="outlined"
                  color="primary"
                  location={LOCATIONS_APP_PAGE}
                >
                  {t('buttons.streamingMarketplace')}
                </Button>
              </div>
            </Grid>
          )}
          {use_fmb && (
            <Grid item xs={12} sm={4}>
              {unique_id ? (
                <>
                  <Typography className="subtitle m-b-20" variant="h6" align="center">
                    {t('appDetails.backToResults.backToTheResults.title')}
                  </Typography>
                  <div className="text-center">
                    <Button
                      className="m-b-20"
                      component={Link}
                      onClick={this.handleSendParentMessage}
                      to={ROUTE_RESULTS}
                      location={LOCATIONS_APP_PAGE}
                    >
                      {t('buttons.backToMyResults')}
                    </Button>
                  </div>
                </>
              ) : (
                <>
                  <Typography className="subtitle m-b-20" variant="h6" align="center">
                    {t('appDetails.backToResults.startPartnerForm.title')}
                  </Typography>
                  <div className="text-center">
                    <Button
                      className="m-b-20"
                      component={Link}
                      onClick={this.handleStartClick}
                      to={ROUTE_START}
                      location={LOCATIONS_APP_PAGE}
                    >
                      {t('buttons.findMyBundle')}
                    </Button>
                  </div>
                </>
              )}
            </Grid>
          )}
        </Grid>
      </FilterWrapper>
    );
  }
}

BackToResults.propTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  data: PropTypes.object,
  partner: PropTypes.object.isRequired,
  analyticsUserId: PropTypes.string.isRequired,
  unique_id: PropTypes.string.isRequired,
};

export default compose(withTranslation(), withRouter)(BackToResults);
